"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.menuItem = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const fa_1 = require("react-icons/fa");
const bi_1 = require("react-icons/bi");
const ai_1 = require("react-icons/ai");
const md_1 = require("react-icons/md");
const si_1 = require("react-icons/si");
const hook_1 = require("../../../../../redux/hook");
const Utils_1 = require("../../../../../utils/Utils");
const io5_1 = require("react-icons/io5");
const ri_1 = require("react-icons/ri");
function SidebarAdmin() {
    const { user } = (0, hook_1.useAppSelector)((state) => state.user);
    return (react_1.default.createElement("div", { className: "navbar-vertical-customisation-v2 no-view-mobile navbar-vertical-customisation-admin" },
        react_1.default.createElement("div", { className: "hoverable", id: "scrollbar" },
            react_1.default.createElement("div", { className: "content-img-logo-admin-sidebar" },
                react_1.default.createElement("img", { src: "/images/appImages/logo.png", alt: "Logo-admin", className: "img-logo-admin-sidebar" })),
            react_1.default.createElement("div", { className: "content mt-3" },
                react_1.default.createElement("div", { className: "move-left-side-menu" }),
                react_1.default.createElement("ul", { className: "nav nav-items-custom flex-column" }, exports.menuItem === null || exports.menuItem === void 0 ? void 0 :
                    exports.menuItem.map((menu, i) => {
                        var _a;
                        return (react_1.default.createElement("li", { className: "nav-item nav-item-vertical-custom", key: i, hidden: (0, Utils_1.hasAccess)(user, (_a = user === null || user === void 0 ? void 0 : user.permissions) === null || _a === void 0 ? void 0 : _a[menu === null || menu === void 0 ? void 0 : menu.field]) },
                            react_1.default.createElement(react_router_dom_1.NavLink, { className: "nav-link nav-link-vertival-custom-admin with-tooltip-menu", to: menu === null || menu === void 0 ? void 0 : menu.path, "data-tooltip-content": menu === null || menu === void 0 ? void 0 : menu.label },
                                react_1.default.createElement("span", { className: "icon-container-nav-link-vertival" }, menu === null || menu === void 0 ? void 0 : menu.icon),
                                react_1.default.createElement("span", { className: "hiddenable-navlink-label" }, menu === null || menu === void 0 ? void 0 : menu.label))));
                    }),
                    ((0, Utils_1.isSuperAdmin)(user)) && (react_1.default.createElement("li", { className: "nav-item nav-item-vertical-custom bug-tracker-li" },
                        react_1.default.createElement("a", { className: "nav-link nav-link-vertival-custom-admin with-tooltip-menu", href: "/log-viewer", "data-tooltip-content": "Log Viewer" },
                            react_1.default.createElement("span", { className: "icon-container-nav-link-vertival" },
                                react_1.default.createElement(io5_1.IoBugOutline, null)),
                            react_1.default.createElement("span", { className: "hiddenable-navlink-label" }, "Log Viewer")))))))));
}
exports.default = SidebarAdmin;
exports.menuItem = [
    {
        path: "/admin/tableau-de-bord",
        label: "Tableau de bord",
        field: "dashboard",
        icon: react_1.default.createElement(bi_1.BiSolidCategory, null),
    },
    {
        path: "/admin/statistiques-et-reporting",
        label: "Statistiques et reporting",
        field: "statistiques-reporting",
        icon: react_1.default.createElement(ri_1.RiBarChartLine, null),
    },
    {
        path: "/admin/socket-io-metrics",
        label: "Socket IO",
        field: "socket-io",
        icon: react_1.default.createElement(si_1.SiSocketdotio, null),
    },
    {
        path: "/admin/api-orm-metrics",
        label: "ORM Dashboard",
        field: "api-orm-metrics",
        icon: react_1.default.createElement(ai_1.AiOutlineConsoleSql, null),
    },
    {
        path: "/admin/rapidos",
        label: "Rapidos",
        field: "rapidos",
        icon: react_1.default.createElement(si_1.SiRapid, null),
    },
    {
        path: "/admin/notifications",
        label: "Notifications",
        field: "notifications",
        icon: react_1.default.createElement(fa_1.FaUserFriends, null),
    },
    // {
    //     path: "/admin/signalements",
    //     label: "Signalements",
    //     field: "signalements",
    //     icon: <FaFlag />,
    // },
    // {
    //     path: "/admin/transactions",
    //     label: "Transactions",
    //     field: "transactions",
    //     icon: <MdLocationCity />,
    // },
    {
        path: "/admin/mes-notifications",
        label: "Mes Notifications",
        field: "mes-notifications",
        icon: react_1.default.createElement(io5_1.IoNotificationsCircleSharp, null),
    },
    {
        path: "/admin/sos-remorquage",
        label: "SOS remorquage",
        field: "toll-points",
        icon: react_1.default.createElement(md_1.MdSpeakerGroup, null),
    },
    {
        path: "/admin/suggestions",
        label: "Suggestions/Remarques",
        field: "suggestions-remarques",
        icon: react_1.default.createElement(fa_1.FaComments, null),
    },
    {
        path: "/admin/utilisateurs",
        label: "Utilisateurs",
        field: "utilisateurs",
        icon: react_1.default.createElement(fa_1.FaUserFriends, null),
    },
    {
        path: "/admin/parametres",
        label: "Paramètres",
        field: "parametres",
        icon: react_1.default.createElement(ai_1.AiFillSetting, null),
    },
    {
        path: "/admin/mon-compte",
        label: "Mon compte",
        field: "mon-compte",
        icon: react_1.default.createElement(fa_1.FaUserFriends, null),
    },
];
